import React from "react";
import { Link, Redirect } from "polyrouter";
import { useTranslation } from "utilities/i18n";
import {
  ServiceNowHookPageFragment,
  useGetServiceNowHookQuery
} from "generated/graphql";
import { ServiceNowNotificationTypeForms } from "./ServiceNowNotificationTypeForms";
import { NameForm } from "./NameForm";

export const ServiceNowWebHookEditForm: React.FC<{
  webHooksId: string;
  hooks: ServiceNowHookPageFragment[];
}> = ({ webHooksId, hooks }) => {
  const { t } = useTranslation();
  const { data, fetching, stale } = useGetServiceNowHookQuery({
    variables: {
      id: webHooksId
    }
  });
  if (fetching || stale) return null;
  if (
    data?.ncServiceNow.webhook === null ||
    data?.ncServiceNow.webhook === undefined
  ) {
    return <Redirect to="../" />;
  }
  const {
    ncServiceNow: { webhook }
  } = data;
  if (webhook?.id !== webHooksId) {
    //There is a bug internal to urql right now that will return the previous results sometimes.
    return null;
  }

  return (
    <>
      <NameForm webHooksId={webHooksId} ac={webhook} hooks={hooks} />
      <ServiceNowNotificationTypeForms webHooksId={webHooksId} ac={webhook} />
      <div
        className="grouping btn-container mb-1 "
        data-testid="webhook-edit-form"
      >
        <Link to="../" className="btn btn-secondary" replace>
          {t("CLOSE")}
        </Link>
      </div>
    </>
  );
};

export default ServiceNowWebHookEditForm;
